<template>
    <div v-if="entry.modifiedBy">
        {{ entry.modifiedBy }} - {{ modifiedDate }}
    </div>
</template>

<script>
import Core from "@/modules/core/service/Core";

export default {
    name: "PAuditModification",

    props: {
        entry: {

        }
    },

    computed: {
        modifiedDate () {
            if (!this.entry) {
                return null;
            }

            return Core.format.date.sdisplay(this.entry.modifiedDate);
        }
    }
}
</script>

<style scoped>

</style>